import { el } from "./dom";
import { getLandingUrl } from "./landingUrl";
import { t } from "@bn-games/i18n-core";

export interface BackToLandingLinkHandle {
  readonly root: HTMLElement;
  destroy(): void;
}

export function createBackToLandingLink(): BackToLandingLinkHandle {
  const landingUrl = getLandingUrl();

  const root = el("a", {
    class: "menu-home-link",
    text: t("auth.backToLanding"),
    attrs: { href: landingUrl + "/" },
  });

  return {
    root,
    destroy(): void {
      // Static link, no listeners to remove — present for API symmetry with
      // createAuthWidget's handle shape.
    },
  };
}
